import useAuthService from "../session/AuthService";

let allowedTestingDomainsIps = ["139.59.37.158"];

let allowedTestingDomains = ["walletpro.betalearnings.com"];

let allowedProductionDomains = ["3.136.26.136"];

let URL = "";
if (
  ["localhost", "127.0.0.1", "172.16.16.59", "172.16.16.52"].includes(
    window.location.hostname
  )
) {
  // URL = `http://${window.location.hostname}:8082/`;
  // URL = `https://walletpro.betalearnings.com/WalletPro_MW/`;
  URL = `http://localhost:8082/`;
  // URL = "http://172.16.16.59:8082/";
} else if (allowedTestingDomains.includes(window.location.hostname)) {
  URL = `https://${window.location.hostname}/WalletPro_MW/`;
} else if (allowedTestingDomainsIps.includes(window.location.hostname)) {
  URL = `http://${window.location.hostname}:8080/WalletPro_MW/`;
} else if (allowedProductionDomains.includes(window.location.hostname)) {
  URL = `http://${window.location.hostname}:8080/WalletPro_MW/`;
} else {
  URL = "https://noaccess.com/youHaveNoAccess/";
}

export const getFilePath = (fileName) => {
  let article;
  if (fileName) {
    if (allowedTestingDomains.includes(window.location.hostname)) {
      article = `https://${window.location.hostname}/WalletPro_MW/auth/assets/${fileName}`;
    } else if (allowedTestingDomainsIps.includes(window.location.hostname)) {
      article = `http://${window.location.hostname}:8080/WalletPro_MW/auth/assets/${fileName}`;
    } else if (["localhost", "127.0.0.1"].includes(window.location.hostname)) {
      article = `http://localhost:8082/auth/assets/${fileName}`;
    } else if (allowedProductionDomains.includes(window.location.hostname)) {
      article = `http://${window.location.hostname}:8080/WalletPro_MW/auth/assets/${fileName}`;
    } else {
      article = `http://139.59.37.158:8080/WalletPro_MW/auth/assets/${fileName}`;
    }
  }
  return article;
};

export const API_URL = URL;

export const isAdmin = true;

export const HTTP_HEADERS = {
  "Content-Type": "application/json",
  Accept: "*/*",
};

export const HEADERS = (key) => {
  return {
    "Content-Type": "application/json",
    Accept: "*/*",
    Authorization: "JWT fefege...",
  };
};

export const AUTH_HEADERS = () => {
  return {
    "Content-Type": "application/json",
    Accept: "*/*",
    Authorization: useAuthService.getToken(),
  };
};
export const HEADERS_MULTIPART = () => {
  return {
    "Content-Type": "multipart/form-data",
    Accept: "*/*",
    Authorization: useAuthService.getToken(),
  };
};
